import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, InverseButton, LoadingWrapper, PageTitle } from 'react-fast-ui';
import PropTypes from 'prop-types';

import AddAccountUserModal from './modal/AddAccountUserModal';
import ViewActivationModal from './ViewActivationModal';
import AccountUserTable from './table/AccountUserTable';
import DAO from '../dao/DAO';
import actions from '../actions/actionTypes';
import actionTypes from '../actions/actionTypes';

const mapStateToProps = (store) => {
  return ({
    team: store.team,
    licensedProducts: store.licensedProducts,
    scoutRoles: store.scoutRoles,
    accessRoles: store.accessRoles,
    recruitRoles: store.recruitRoles,
    accountUsers: store.accountUsers,
  });
};

class AccountUsersPage extends Component {

  static contextTypes = {
    dao: PropTypes.instanceOf(DAO),
    ngUser: PropTypes.object,
    onError: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  state = {
    newUserModal: false,
    activationModel: false,
    loadingAccountUsers: (null: ?Promise),
    licensedSeats: [],
  }

  componentDidMount() {
    this.fetchAccountUsers();
    this.updateLicensedProducts();
    this.fetchLicenseSeats();
  }

  updateLicensedProducts() {
    const { dao, ngUser, onError } = this.context;
    const { dispatch } = this.props;
    dao.licensedProducts.fetchLicensedProducts({ start: 0, count: 20, accountId: ngUser.accountId })
      .then((licensedProducts) => {
        dispatch({ type: actions.GET_LICENSED_PRODUCT_SUCCESS, licensedProducts });
        this.updateRoles(licensedProducts);
      })
      .catch(onError);
  }

  fetchAccountUsers = () => {
    const { dao, ngUser, onError } = this.context;
    const { dispatch } = this.props;
    const loadingAccountUsers = dao.account.fetchAccountUsers(ngUser.accountId)
      .then((accountUsers) => {
        dispatch({ type: actions.GET_ACCOUNT_USERS_SUCCESS, accountUsers });
        this.setState({ loadingAccountUsers: null });
      })
      .catch(onError);

    this.setState({ loadingAccountUsers });
  }

  updateRoles(licensedProducts) {
    const { dao } = this.context;
    const { dispatch } = this.props;
    _.map(licensedProducts, (item) => {
      if ([ 'FastScout', 'FastAccess' ].includes(item.product.displayName)) {
        dao.licensedProducts.fetchRoles({ start: 0, count: 20, productId: item.product.id })
          .then((roles) => {
            const sortedRoles = _.sortBy(roles, role => role.name);
            switch (item.product.displayName) {
              case 'FastScout':
                return dispatch({ type: actionTypes.GET_FASTSCOUT_ROLES_SUCCESS, scoutRoles: sortedRoles });
              case 'FastAccess':
                return dispatch({ type: actionTypes.GET_FASTACCESS_ROLES_SUCCESS, accessRoles: sortedRoles });
            }
          });
      }
    });
  }

  handleAddUser = (user, isEditing) => {
    const { dao, ngUser, onError, onSuccess } = this.context;
    if (isEditing) {
      dao.account.updateAccountUser({ ...user, accountId: ngUser.accountId }, user.userId)
        .then(() => {
          onSuccess('Account user updated!');
          this.updateLicensedProducts();
          this.fetchAccountUsers();
          this.fetchLicenseSeats();
        })
        .catch(onError);
    } else {
      dao.account.addNewAccountUser({ ...user, accountId: ngUser.accountId })
        .then(() => {
          onSuccess('New account user added!');
          this.updateLicensedProducts();
          this.fetchAccountUsers();
          this.fetchLicenseSeats();
        })
        .catch(onError);
    }
  };

  fetchLicenseSeats() {
    const { dao, ngUser, onError } = this.context;
    dao.licensedProducts.fetchLicensedProductSeats({ start: 0, count: 20, accountId: ngUser.accountId })
      .then((licensedSeats) => {
        this.setState({ licensedSeats });
      })
      .catch(onError);
  };

  filteredLicenseProducts() {
    const { licensedProducts } = this.props;
    return _.filter(licensedProducts, product => product.quantity - product.allocated >= 0);
  }

  render() {
    const { team, scoutRoles, accessRoles, recruitRoles, accountUsers, licensedProducts } = this.props;
    const { newUserModal, activationModel, loadingAccountUsers, licensedSeats } = this.state;
    const primaryColor = `#${team.getPrimaryColor()}`;
    const filteredLicenseProducts = this.filteredLicenseProducts();

    return (
      <PageTitle title='Account Users'>
        <div className="adminPortal">
          <AddAccountUserModal
            featureFlags={this.props.featureFlags}
            open={newUserModal}
            scoutRoles={scoutRoles}
            accessRoles={accessRoles}
            licensedProducts={filteredLicenseProducts}
            accentColor={primaryColor}
            isEditing={false}
            onClose={() => this.setState({ newUserModal: false })}
            onSave={this.handleAddUser}
          />
          <ViewActivationModal
            open={activationModel}
            licensedProducts={filteredLicenseProducts}
            accentColor={primaryColor}
            onClose={() => this.setState({ activationModel: false })}
          />
          <header
            style={{ minHeight: 40, borderBottom: '1px solid #d8d8d8' }}>
            <div className="mg-top-sm" style={{ right: '44px', position: 'absolute' }}>
              <InverseButton
                className="btn-primary-admin"
                onClick={() => this.setState({ activationModel: true })}
                style={{ backgroundColor: `${primaryColor}` }}>
                <span id="viewActivationsButton">VIEW ACTIVATIONS</span>
              </InverseButton>
              <InverseButton
                className="mg-left-md btn-primary-admin"
                onClick={() => this.setState({ newUserModal: true })}
                style={{ backgroundColor: `${primaryColor}` }}>
                <Icon name='plus'/>
                <span className="mg-left-md" id="addUserButton">ADD USER</span>
              </InverseButton>
            </div>
          </header>
          <div className="display-inline-block full-width" style={{ backgroundColor: '#fafafa' }}>
            <main style={{ padding: '0px 44px 20px' }}>
              <section className="tile-pill pd-md mg-bottom-lg mg-top-xl">
                <div>
                  <header
                    style={{
                      width: '100%',
                      borderBottom: `2px solid ${primaryColor}`,
                      borderBottomColor: `${primaryColor}`,
                      fontFamily: '"Futura PT W01 Bold", sans-serif',
                      textTransform: 'uppercase',
                      fontSize: 23,
                      borderTopLeftRadius: '0.3em',
                      borderTopRightRadius: '0.3em'
                    }}>
                    <div
                      className="display-flex align-items-center justify-content-space-between"
                      style={{ paddingBottom: 6 }}>
                      Users
                    </div>
                  </header>
                  <LoadingWrapper loading={Boolean(loadingAccountUsers)}>
                    <AccountUserTable
                      featureFlags={this.props.featureFlags}
                      scoutRoles={scoutRoles}
                      accessRoles={accessRoles}
                      accentColor={primaryColor}
                      licensedProducts={licensedProducts}
                      accountUsers={accountUsers}
                      licensedSeats={licensedSeats}
                      onUpdate={this.fetchAccountUsers}
                      onSave={this.handleAddUser}/>
                  </LoadingWrapper>
                </div>
              </section>
            </main>
          </div>
        </div>
      </PageTitle>
    );
  }
}

export default connect(mapStateToProps)(AccountUsersPage);